<div class="row query" style="margin-left: 0px;">
    <div class="col-sm-6 description" *ngIf="!savedQuery">
        <a class="query-name" href="javascript:void(0)" (click)="loadQuery(query)">{{query.queryName}}</a>
    </div>
    <div class="col-sm-6 query-date text-right" *ngIf="!savedQuery">
        <div>{{ query.startDate | date:'short'}}</div>
    </div>
    <div class="col-sm-9 description" *ngIf="savedQuery">
        <a class="query-name" href="javascript:void(0)" (click)="loadSavedQuery(query)">{{query.queryName}}</a>
    </div>
    <div class="col-sm-3 text-right" *ngIf="savedQuery">
        <mat-icon style="cursor: pointer;" (click)="deleteSavedQuery(query)">delete_forever</mat-icon>
    </div>
    <div class="col-sm-12 query-code">
        <div *ngIf="query.hasOwnProperty('dataSets') && query['dataSets'].length > 0">
            <div class="selection-header">Data Sets: <span class="query-selections">{{ displaySelectedDataSets(query) }}</span></div>
        </div>
        <div *ngIf="query.hasOwnProperty('indicationGroups') && query['indicationGroups'].length > 0">
            <div class="selection-header">Indications: <span class="query-selections">{{ displaySelectedFilteredIndicationNames(query) }}</span></div>
        </div>
    </div>
</div>